import project1 from "../assets/project-1.png";
import project2 from "../assets/project-2.png";
import project3 from "../assets/project-3.png";
import project4 from "../assets/project-4.png";
import project5 from "../assets/project-5.png";

export const projects = [
  {
    image: project1,
    title: "Ranger Packers & Movers Website",
    description:
      "A responsive logistics service website showcasing booking, services, and gallery features.",
    link: "",
  },
  {
    image: project5,
    title: "PrefAI",
    description:
      "Developed a full-stack application using React-Native, Integrated with ChatGPT API, Stripe payments, push notifications, document vault, calendar, and Google Speech-to-Text/Text-to-Speech features etc.",
    link: "",
  },
  {
    image: project2,
    title: "Bolger – Blog Website",
    description:
      "A clean, responsive blog platform built with intuitive UI to create and explore tech blogs easily.",
    link: "https://bolger.onrender.com/",
  },
  {
    image: project4,
    title: "Manage with Motion – Auth Screens",
    description:
      "A clean and modern authentication flow featuring welcome, login, and registration screens with social sign-in options.",
    link: "",
  },
  {
    image: project3,
    title: "Product Hub – E-commerce App",
    description:
      "A sleek and user-friendly e-commerce platform with product listing, registration, and detail views built for seamless shopping experiences.",
    link: "https://oneble.onrender.com/",
  },
];
